var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('hr'),_c('p',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.footerMsg())}}),_c('br'),_vm._v(" "+_vm._s(_vm.date)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }